import * as React from 'react'
import { styled } from 'next-yak'

import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'
import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'

const VIDEO_PATH = (
  <g>
    <path d="M14.3059 0.5H1.69412C0.752941 0.5 0 1.25294 0 2.19412V14.7118C0 15.6529 0.752941 16.4059 1.69412 16.4059H14.2118C15.1529 16.4059 15.9059 15.6529 15.9059 14.7118V2.19412C16 1.25294 15.2471 0.5 14.3059 0.5ZM10.0706 1.91176H11.5765V3.32353H10.0706V1.91176ZM7.24706 1.91176H8.65882V3.32353H7.24706V1.91176ZM4.32941 1.91176H5.83529V3.32353H4.32941V1.91176ZM1.92 1.91176H2.91765V3.32353H1.41176V2.42C1.41176 2.13765 1.63765 1.91176 1.92 1.91176ZM1.41176 13.6765H2.91765V15.0882H1.92C1.63765 15.0882 1.41176 14.8624 1.41176 14.58V13.6765ZM5.83529 15.0882H4.32941V13.6765H5.83529V15.0882ZM8.65882 15.0882H7.24706V13.6765H8.65882V15.0882ZM11.6706 15.0882H10.1647V13.6765H11.6706V15.0882ZM14.08 15.0882H13.0824V13.6765H14.5882V14.58C14.5882 14.8624 14.3624 15.0882 14.08 15.0882ZM14.5882 12.2647H1.41176V4.73529H14.5882V12.2647ZM14.5882 3.32353H13.0824V1.91176H14.08C14.3624 1.91176 14.5882 2.13765 14.5882 2.42V3.32353Z" />
    <path d="M9.50554 8.8762L6.96436 10.3821C6.68201 10.5703 6.39966 10.3821 6.39966 10.0056V6.99385C6.39966 6.7115 6.77613 6.52326 6.96436 6.61738L9.50554 8.12326C9.69378 8.3115 9.69378 8.68797 9.50554 8.8762Z" />
  </g>
)

const ID = 'video-stroke-glyph-icon'

export function VideoSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 16 17">
      {VIDEO_PATH}
    </symbol>
  )
}

const VideoStandaloneContent = standalone(VideoSymbol, ID)

export const Video = styled(function VideoComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="video">
      <VideoStandaloneContent />
    </Icon>
  )
})``

export const VideoLightweight = styled(function VideoComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="video-light-weight">
      {lightweight(ID)}
    </Icon>
  )
})``
